import { Flex, Stack, VStack,Text } from '@chakra-ui/react';
import React from 'react'
import { Gallery } from "react-grid-gallery";


const Dessert = () => {
  return (
    <div>
      {Hero()}
      <Gallery images={images} />
    </div>
  )
}



const Hero = () => {
  return (
    <Flex
      w={"full"}
      h={"50vh"}
      backgroundImage={require("../imgs/dessert.jpg")}
      backgroundSize={"cover"}
      backgroundPosition={"center center"}
    >
      <VStack
        w={"full"}
        justify={"center"}
        px={{ base: 4, md: 8 }}
        bgGradient={"linear(to-r, blackAlpha.600, transparent)"}
      >
        <Stack maxW={"2xl"} align={"flex-start"} spacing={6}>
          <Text
            color={"white"}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={{ base: "3xl", md: "4xl" }}
            textAlign="center"
          >
            Dessert
          </Text>
          <Text
            color={"white"}
            fontWeight={300}
            lineHeight={1.2}
            fontSize={{ base: "md", md: "2md" }}
          >
           With Miss.Y Cake, you can make every occasion in your life special!
          </Text>
        </Stack>
      </VStack>
    </Flex>
  );
};


const images = [
  {
     src: require("../imgs/showcase/28.jpg"),
     width: 500,
     height: 500,
  },
  {
    src: require("../imgs/showcase/29.jpg"),
    width: 500,
    height: 500,
 },
 {
  src: require("../imgs/showcase/30.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/34.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/35.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/37.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/38.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/39.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/40.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/41.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/42.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/43.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/44.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/50.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/55.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/60.jpg"),
  width: 500,
  height: 500,
},
{
  src: require("../imgs/showcase/61.jpg"),
  width: 500,
  height: 500,
},
];

export default Dessert
